import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class EventUsefulInformation extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'EventUsefulInformation';

    // Define default properties here
    static instanceDefaults() {
        return {
            content: '',
            content_tc: '',
            content_sc: '',
            openingHours: '',
            reservation: '',
        }
    }
}

const servicePath = 'f-useful-information';
const servicePlugin = makeServicePlugin({
    Model: EventUsefulInformation,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin